// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__2u2__"};